module.exports = {
          srcSet: __webpack_public_path__ + "189261541c0d3f8cfa51a3e1907e50fe-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "189261541c0d3f8cfa51a3e1907e50fe-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "189261541c0d3f8cfa51a3e1907e50fe-120.png",
          toString:function(){return __webpack_public_path__ + "189261541c0d3f8cfa51a3e1907e50fe-120.png"},
          
          width: 120,
          height: 120
        }